/* eslint-disable */
import { Reducer } from 'redux'
import { toast } from 'react-toastify'
import { call, put, takeLatest, all } from 'redux-saga/effects'
import { SagaAction, GetResponse } from 'src/@types'
import { setLoading } from './loading'
import { API } from 'src/services/config'

interface ListaModificados {
  observacoes: string[]
}

export interface IAnimalRecord {
  data: string
  id: string
  idAnimal: string
  idFazenda: string
  idFazendaIdAnimal: string
  idMovimentacao: string
  key: string
  listaModificados: ListaModificados
  username: string
}

export interface AnimalRecordsState {
  isLoading: boolean
  list: Array<IAnimalRecord>
}

const customModule = '@ANIMAL_RECORDS'

const GET = {
  REQUEST: `${customModule}/GET_REQUEST`,
  SUCCESS: `${customModule}/GET_SUCCESS`
}

const SET_FETCHING = `${customModule}/SET_FETCHING`

const initialState: AnimalRecordsState = {
  isLoading: false,
  list: []
}

export const animalRecordsReducer: Reducer<AnimalRecordsState> = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET.REQUEST:
      return { ...state, isLoading: true }

    case GET.SUCCESS:
      return { ...state, list: payload, isLoading: false }
    default:
      return state
  }
}

export const setFetching = (data: boolean) => ({ type: SET_FETCHING, payload: data })
export const getAnimalRecordsList = (farmId: string, animalId: string) => ({
  type: GET.REQUEST,
  payload: { farmId, animalId }
})

const ROUTE = '/entity/AnimalMovimentacao'

// eslint-disable-next-line
function* get({ payload }: SagaAction<{ farmId: string; animalId: string }>) {
  const { farmId, animalId } = payload
  try {
    yield put(setLoading(true))
    const { data }: GetResponse<any> = yield call(API.get, `${ROUTE}/${farmId}/${animalId}`)
    yield put({ type: GET.SUCCESS, payload: data })
    yield put(setLoading(false))
  } catch (error: any) {
    const message = error?.response?.data || 'Erro ao buscar registros. Tente novamente.'
    toast.error(message)
    yield put(setLoading(false))
  }
}

export const AnimalRecordsSaga = all([takeLatest(GET.REQUEST, get)])
